import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_DELETE_INVITATIONS } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteInvitation = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [deleteOrgInvite, res] = esApi.endpoints.deleteOrgInvite.useMutation()

  const deleteInvitation = useCallback(
    async (inviteId: number): Promise<boolean> => {
      try {
        await deleteOrgInvite({
          orgId: orgId.toString(),
          inviteId,
        }).unwrap()

        dispatch(
          createNotification({
            'delete-invitation-success': {
              type: 'success',
              message: 'Invitation deleted successfully.',
            },
          }),
        )

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'delete-invitation-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_DELETE_INVITATIONS),
            },
          }),
        )

        return false
      }
    },
    [orgId, deleteOrgInvite, dispatch],
  )

  return [deleteInvitation, res] as const
}
